import Page from './notification.page'

let routes = [
  {
    path: '/notifications',
    name: 'notifications',
    component: Page
  }
]

export default routes
